const Hydrator = require('@/lib/Hydration/Hydrator');

/**
 * This is a simple way to use the Hydrator to hydrate an object.
 * You can now use this instead of having to inject Hydrator as a dependency.
 *
 * @param {object} data
 * @param {object} model
 */
const hydrate = (data, model) => {
    const hydrator = new Hydrator();
    hydrator.hydrate(data, model);

    return model;
};

/**
 * @param {array} data
 * @param {function} modelFactory Function to return an instance of a model e.g. () => new Model;
 *
 * @return {Array}
 */
const hydrateArray = (data, modelFactory) => {
    const hydrator = new Hydrator();

    let results = [];
    // This is forEach instead of a map because we want to reset array keys.
    data.forEach((datum) => results.push(hydrator.hydrate(datum, modelFactory())));

    return results;
};

/**
 * During hydration, an `isHydrated` property is added to the object.
 * During tests this can be inconvenient, so this function can be used to remove it.
 *
 * @param {object} obj
 */
const cleanHydratedObject = (obj) => {
    // Recursively remove the property from all nested objects.
    for (const key in obj) {
        if (obj[key] !== null && typeof obj[key] === 'object') {
            cleanHydratedObject(obj[key]);
        }
    }

    delete obj.isHydrated;
};

module.exports = {
    cleanHydratedObject,
    hydrate,
    hydrateArray,
};
